import React from "react";

export default function SMEChallenges() {
    return (
        <div className="bg-white">
            <div className="px-4 sm:px-14 lg:px-24 py-8 text-black text-[14px] md:text-[32px] leading-tight">
                <h1 className="text-black md:text-[54px] text-[16px] font-extrabold text-center">Challenges</h1>
                <p className="mb-8 md:text-[36px] text-[12px] font-extrabold text-center">Top Challenges Faced by Farmers</p>

                <div className="space-y-4 text-[10px] sm:text-[20px]">
                    {[
                        {
                            title: "Limited Access to Finance",
                            description: "Many farmers lack access to affordable credit and insurance.",
                            solution: "Develop inclusive agricultural financing, microloans, and mobile banking services tailored to smallholders."
                        },
                        {
                            title: "Poor Infrastructure",
                            description: "Inadequate roads, storage, and market facilities hinder distribution and increase post-harvest losses.",
                            solution: "Invest in rural infrastructure, including roads, warehouses, and market access points."
                        },
                        {
                            title: "Climate Change & Unpredictable Weather",
                            description: "Droughts, floods, and changing weather patterns disrupt farming cycles.",
                            solution: "Promote climate-smart agriculture, drought-resistant seeds, and improved weather forecasting tools."
                        },
                        {
                            title: "Low Access to Technology and Inputs",
                            description: "Limited availability of quality seeds, fertilizers, and modern tools.",
                            solution: "Encourage public-private partnerships to improve input supply chains and subsidize access for small-scale farmers."
                        },
                        {
                            title: "Land Tenure Insecurity",
                            description: "Many farmers work without formal land rights, discouraging long-term investment.",
                            solution: "Implement land reforms and promote secure, documented land ownership."
                        },
                        {
                            title: "Limited Agricultural Extension Services",
                            description: "Farmers often lack access to updated farming knowledge and practices.",
                            solution: "Strengthen extension services using mobile platforms, local training centers, and demonstration farms."
                        },
                        {
                            title: "Market Access and Price Volatility",
                            description: "Farmers struggle to connect with profitable markets and face unstable prices.",
                            solution: "Support farmer cooperatives, develop value chains, and use digital platforms to connect farmers with buyers."
                        },
                        {
                            title: "Pests and Diseases",
                            description: "Crop and livestock pests can wipe out harvests and income.",
                            solution: "Increase research on pest control, and provide early warning systems and access to effective pesticides or biological controls."
                        },
                        {
                            title: "Youth Disinterest in Agriculture",
                            description: "Agriculture is seen as unprofitable and labor-intensive.",
                            solution: "Promote agribusiness, use of technology, and access to land and finance for young entrepreneurs."
                        }
                    ].map((item, idx) => (
                        <div key={idx}>
                            <p className="font-bold mb-2">{item.title}</p>
                            <p className="mb-2">{item.description}</p>
                            <p><span className="font-bold">Solution:</span> {item.solution}</p>
                        </div>
                    ))}
                </div>

                <style jsx>{`
                    @media (max-width: 640px) {
                        div {
                            font-size: 14px;
                        }
                    }
                `}</style>
            </div>
        </div>
    );
}
